module.exports = __webpack_public_path__ + "static/img/bg-tr.327c563b.png";